function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}
module.exports = _isObject;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_isObject.js
// module id = 724
// module chunks = 0